import { SET_ZOOMING_TO_FEATURE } from '@/actions/types'

/**
 * Reducer for tracking zoom-to-feature operations
 * Used to prevent LabelFeatures from rebuilding the layer array during zoom transitions
 * which could cause hidden layers to temporarily appear visible
 */
export default function ZoomingToFeatureReducer(state = false, action) {
  switch (action.type) {
    case SET_ZOOMING_TO_FEATURE: {
      return action.payload
    }
    default:
      return state
  }
}
